module.exports = __webpack_public_path__ + "img/vipbg.4555ff30.png";